/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, Input, OnInit, signal} from '@angular/core';

import template from './publisher-info.component.html';
import {OBJECT_TYPE} from '../constants/object-type';
import {AdnLogService} from '../../../components/util/adn-log.service';
import {PublisherInfoApiService, PublisherInfoObjectType} from './publisher-info-api.service';

@Component({
  standalone: false,
  selector: 'adn-publisher-info',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublisherInfoComponent implements OnInit {
  @Input() id: string;
  @Input() infoReset: any;
  @Input() objTypeRef: string;

  readonly loading = signal(false);
  readonly publisherInfo = signal<any>(null);

  constructor(
    private readonly publisherInfoApi: PublisherInfoApiService,
    private readonly adnLog: AdnLogService
  ) {
  }

  ngOnInit(): void {
    const obj = OBJECT_TYPE[this.objTypeRef];
    if (!obj) {
      this.adnLog.warn('need a good object reference and this is not it: ' + this.objTypeRef);
      return;
    }

    const pubInfoReset = () => {
      this.loading.set(true);
      this.publisherInfoApi.get(obj.apiParam as PublisherInfoObjectType, this.id).subscribe({
        next: (data) => {
          this.loading.set(false);
          this.publisherInfo.set(data);
        },
        error: () => {
          this.loading.set(false);
          this.publisherInfo.set(null);
        }
      });
    };

    if (this.infoReset) {
      this.infoReset.info = pubInfoReset;
    } else {
      pubInfoReset();
    }
  }

  togglePubShow(pub: any): void {
    pub.show = !pub.show;
    this.touchPublisherInfo();
  }

  collapsePub(pub: any): void {
    pub.show = false;
    this.touchPublisherInfo();
  }

  toggleSiteShow(site: any): void {
    site.show = !site.show;
    this.touchPublisherInfo();
  }

  collapseSite(site: any): void {
    site.show = false;
    this.touchPublisherInfo();
  }

  /** Re-emit after in-place expand/collapse so OnPush re-reads row state. */
  private touchPublisherInfo(): void {
    const current = this.publisherInfo();
    if (!current) {
      return;
    }
    this.publisherInfo.set({...current, publishers: (current.publishers || []).slice()});
  }
}
